































































































































import Vue from 'vue';
import FairTag from './fairTag.vue';
import { getXOssProcess } from '~/util/common';
import { mapState } from 'vuex';
import { $cookies } from '~/util/api';

export default Vue.extend({
    name: 'Goods',
    data() {
        return {
            isLogin: false,
        };
    },
    computed: {
        ...mapState({
            stateIsLogin: (state: any) => state.global.isLogin,
        }),
    },
    watch: {
        stateIsLogin(v) {
            this.isLogin = v;
        },
    },
    methods: {
        getXOssProcess,
        handleDetail() {
            // this.$router.push({
            //   path: `/exhibition/${this.data.exhibitionId || this.data.id}.html`
            // })
            let text = this.$router.resolve({
                path: `/exhibition/${
                    this.data.exhibitionId || this.data.id
                }.html`,
            });
            window.open(text.href, '_blank');
        },
        shouldLogin() {
            const access_token = $cookies.get('access_token');
            // 获取不到token为未登录, 前往登录页
            if (!access_token) {
                this.$login.show();
                // this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
            }
            return !!access_token;
        },
    },
    components: { FairTag },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        isHot: {
            type: Boolean,
            default: false,
        },
        smallTag: {
            type: Boolean,
            default: false,
        },
    },
});
